import React from 'react';
import { Navigate } from 'react-router-dom';
import { useFeatures } from '../services/features';
import { hasValidToken } from '../services/api';

const PrivateRoute = ({ element: Component, role, feature }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const features = useFeatures();

    if (!user) {

        return <Navigate to="/login" />;
    }

    // Token wygasł (np. powrót po przerwie) — od razu do logowania, zanim widok odpyta API
    if (!hasValidToken()) {
        return <Navigate to="/login?expired=1" />;
    }


    const allowedRoles = Array.isArray(role) ? role : [role];

    if (!allowedRoles.includes(user.role)) {

        return <Navigate to="/unauthorized" />;
    }


    // Trasy wyłączonego modułu (np. fakturowania) nie istnieją w tej instancji
    if (feature) {
        if (!features) return null;
        if (!features[feature]) return <Navigate to="/" />;
    }


    return <Component />;
};

export default PrivateRoute;
